module.exports = __webpack_public_path__ + "img/sdg15_jp.06c1714f.png";